import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from '../../common/app';
import Component from '../Component';
import Icon from './Icon';
import LoadingIndicator from './LoadingIndicator';
import classList from '../utils/classList';
import Button from './Button';
export default class Input extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }
  view(vnode) {
    var _this$attrs$stream, _this$attrs;
    const _ref = this.attrs.inputAttrs || {},
      {
        className: inputClassName
      } = _ref,
      inputAttrs = _objectWithoutProperties(_ref, _excluded);
    const value = this.attrs.value || ((_this$attrs$stream = (_this$attrs = this.attrs).stream) == null ? void 0 : _this$attrs$stream.call(_this$attrs)) || '';
    return m("div", {
      className: classList('Input', this.attrs.className, {
        'Input--withPrefix': this.attrs.prefixIcon,
        'Input--withClear': this.attrs.clearable
      })
    }, this.attrs.prefixIcon && m(Icon, {
      name: classList(this.attrs.prefixIcon, 'Input-prefix-icon')
    }), this.input({
      inputClassName,
      value,
      inputAttrs
    }), this.attrs.loading ? m(LoadingIndicator, {
      size: "small",
      display: "inline",
      containerClassName: "Button Button--icon Button--link"
    }) : null, this.attrs.clearable && value && !this.attrs.loading ? m(Button, {
      className: "Input-clear Button Button--icon Button--link",
      onclick: this.clear.bind(this),
      "aria-label": this.attrs.clearLabel || app.translator.trans('core.lib.input.clear_button'),
      type: "button",
      icon: "fas fa-times-circle"
    }) : null);
  }
  input(_ref2) {
    let {
      inputClassName,
      value,
      inputAttrs
    } = _ref2;
    const attrs = _objectSpread({
      className: classList('FormControl', inputClassName),
      type: this.attrs.type || 'text',
      value: value,
      oninput: e => {
        var _this$onchange;
        return (_this$onchange = this.onchange) == null ? void 0 : _this$onchange.call(this, e.target.value);
      },
      'aria-label': this.attrs.ariaLabel,
      placeholder: this.attrs.placeholder,
      readonly: this.attrs.readonly || undefined,
      disabled: this.attrs.disabled || undefined
    }, inputAttrs);
    if (this.attrs.renderInput) {
      return this.attrs.renderInput(attrs);
    }
    return m("input", attrs);
  }
  onchange(value) {
    if (this.attrs.stream) {
      this.attrs.stream(value);
    } else {
      var _this$attrs$onchange, _this$attrs2;
      (_this$attrs$onchange = (_this$attrs2 = this.attrs).onchange) == null || _this$attrs$onchange.call(_this$attrs2, value);
    }
  }
  clear() {
    this.onchange('');
  }
}
flarum.reg.add('core', 'common/components/Input', Input);